import { useTranslations } from 'next-intl';

import Link from '@commons/components/Link';
import Text from '@commons/components/Text';
import BaseContainer from '@commons/containers/BaseContainer';
import Flex from '@commons/containers/Flex';

import type { GardaWorldBusiness } from '.';
import styles from './Desktop.module.scss';

type Props = {
  businesses: readonly GardaWorldBusiness[];
};

/**
 * GardaWorld Footer BusinessMenuDesktop component.
 */

const BusinessMenuDesktop = ({ businesses }: Props) => {
  const t = useTranslations('footer');

  const renderedLinks = businesses.map((business, index) => {
    const isLast = index === businesses.length - 1;

    return (
      <Flex.Item
        border={!isLast ? 'right' : undefined}
        paddingRight="xs"
        className={styles.item}
        key={business}
      >
        <Link reverse href={t(`links.${business}.url`)} level="body-sm">
          {t(`links.${business}.text`)}
        </Link>
      </Flex.Item>
    );
  });

  return (
    <BaseContainer>
      <Text weight="bold">{t('ourBusinesses')}</Text>
      <Flex gap="xs" wrap="wrap" width={12} direction="row" className={styles.menu}>
        {renderedLinks}
      </Flex>
    </BaseContainer>
  );
};

export default BusinessMenuDesktop;
